import { render, staticRenderFns } from "./dish-schedule.vue?vue&type=template&id=2404565a"
import script from "./dish-schedule.vue?vue&type=script&lang=js"
export * from "./dish-schedule.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports